/**
 * @author Maven Trading Team
 * @description Business/state logic and event wiring for payment-method-section. Decides when to show/hide gateways and Stripe section, and triggers UI controller actions.
 */

import { get_user_country_or_detect } from "@/lib/location/country-detection";
import {
  is_gateway_allowed,
  get_plugin_by_id,
} from "@/plugins/payment-plugin-registry.js";
import {
  set_gateway_visibility,
  get_visible_gateways_count,
  show_no_payment_methods_message,
  hide_no_payment_methods_message,
  show_payment_section,
  hide_all_payment_sections,
} from "./checkout-ui-actions.js";
import { show_checkout_error } from "./checkout-ui-actions.js";
import { PAYMENT_ERROR_CODES } from "@/lib/constants/payment-error-constants";

/**
 * Filters and toggles payment gateways by user country
 * @returns {Promise<void>}
 */
const filter_payment_gateways = async () => {
  const country_code = await get_user_country_or_detect();

  const container = document.querySelector("[data-payment-method-section]");
  const gateway_nodes = container?.querySelectorAll(".payment-gateway") || [];
  gateway_nodes.forEach((node) => {
    const element = node;
    const gateway_id = element?.dataset?.gatewayId || "";
    if (!gateway_id) return;
    const allowed = is_gateway_allowed(gateway_id, country_code);
    set_gateway_visibility({ gateway_id, is_allowed: allowed });
  });

  const visible_count = get_visible_gateways_count();
  if (visible_count === 0) {
    show_no_payment_methods_message();
  } else {
    hide_no_payment_methods_message();
  }
};

/**
 * Initializes payment method section: filters, wires listeners, selects gateway
 * @returns {void}
 */
export const init_payment_method_section = () => {
  const container = document.querySelector("[data-payment-method-section]");
  if (!container) return;

  // filter_payment_gateways();
};

export const remove_payment_method_section = () => {
  const section = document.getElementById("payment-method-section");
  section?.remove();
};

export const get_selected_payment_method = () => {
  const selected_input = document.querySelector(
    'input[name="payment_method"]:checked',
  );
  return selected_input?.value || "";
};

export const initialize_selected_gateway_ui = ({ gateway_id }) => {
  const plugin = get_plugin_by_id(gateway_id);
  if (plugin?.initialize_ui) {
    Promise.resolve(plugin.initialize_ui()).catch(() => {
      show_checkout_error({
        error_type:
          PAYMENT_ERROR_CODES.PAYMENT_GATEWAY_UI_INITIALIZATION_FAILED,
        order_id: undefined,
      });
    });
  }
};
